import agent from "../../../api/agent";
export const list = (pagerInputModel) =>
  agent.requests.post(`/city/getlist`, pagerInputModel);
export const create = (city) => agent.requests.post(`/city/create`, city);
export const update = (city) => agent.requests.post(`city/update`, city);
